/**
 * Section: Hub Peignes — catégorie → produits (sans sous-catégories).
 */

(function () {
  'use strict';

  function getQueryParam(name) {
    try {
      var params = new URLSearchParams(window.location.search || '');
      return params.get(name);
    } catch (err) {
      return null;
    }
  }

  function sortVisibleProducts(container, order) {
    var wrap = container.querySelector('.fb-hub__products');
    if (!wrap) return;
      var nodes = Array.prototype.slice.call(wrap.querySelectorAll('[data-fb-product]'));
    var visible = nodes.filter(function (a) {
      return !a.hidden;
    });
    var hidden = nodes.filter(function (a) {
      return a.hidden;
    });
      visible.sort(function (a, b) {
      var la = a.querySelector('.fb-hub__product-label') || a.querySelector('.product-item__title');
      var lb = b.querySelector('.fb-hub__product-label') || b.querySelector('.product-item__title');
      var ta = la ? la.textContent.trim() : (a.textContent || '').trim();
      var tb = lb ? lb.textContent.trim() : (b.textContent || '').trim();
      if (order === 'za') return tb.localeCompare(ta, 'fr', { sensitivity: 'base' });
      return ta.localeCompare(tb, 'fr', { sensitivity: 'base' });
    });
    visible.concat(hidden).forEach(function (node) {
      wrap.appendChild(node);
    });
  }

  function initHubNavigator(container) {
    if (!container || container.dataset.hubNavBound === '1') return;
    if (container.getAttribute('data-fb-hub-mode') !== 'link') return;
    if (container.getAttribute('data-fb-hub-layout') !== 'cat-product') return;

    var dialog = container.querySelector('[data-fb-filter-dialog]');

    function catButtons() {
      return container.querySelectorAll('[data-fb-cat][data-fb-cat-key]');
    }
    function productLinks() {
      return container.querySelectorAll('[data-fb-product][data-fb-parent-cat]');
    }

    var cats = catButtons();
    var products = productLinks();

    if (!products.length) return;

    var qsCat = getQueryParam('fb_cat');
    var qsProd = getQueryParam('fb_product');
    var activePriceFilter = 'all';

    function setQueryParams(next) {
      try {
        var u = new URL(window.location.href);
        Object.keys(next).forEach(function (k) {
          var v = next[k];
          if (v === null || v === undefined || v === '') u.searchParams.delete(k);
          else u.searchParams.set(k, v);
        });
        window.history.replaceState({}, '', u.toString());
      } catch (err) {
        // ignore
      }
    }

    function updateProductCount() {
      var el = container.querySelector('[data-fb-product-count]');
      if (!el) return;
      var n = 0;
      productLinks().forEach(function (a) {
        if (!a.hidden) n += 1;
      });
      el.textContent = String(n);
    }

    function parsePriceNumber(raw) {
      if (raw == null) return NaN;
      var s = String(raw).trim();
      if (!s) return NaN;
      var normalized = s.replace(/\s/g, '').replace(',', '.').replace(/[^0-9.]/g, '');
      if (!normalized) return NaN;
      var n = Number(normalized);
      return isNaN(n) ? NaN : n;
    }

    function productPrice(node) {
      if (!node) return NaN;
      var rawAttr = node.getAttribute('data-fb-price-value') || '';
      var n = parsePriceNumber(rawAttr);
      if (!isNaN(n)) return n;
      var priceEl = node.querySelector('.price-item--regular, .fb-hub__product-price, .product-item__price');
      return parsePriceNumber(priceEl ? priceEl.textContent : '');
    }

    function matchesPriceFilter(node) {
      if (activePriceFilter === 'all') return true;
      var p = productPrice(node);
      if (isNaN(p)) return false;
      if (activePriceFilter === 'lt50') return p < 50;
      if (activePriceFilter === '50-100') return p >= 50 && p <= 100;
      if (activePriceFilter === '100-200') return p > 100 && p <= 200;
      if (activePriceFilter === 'gt200') return p > 200;
      return true;
    }

    function setActivePriceButton(value) {
      container.querySelectorAll('[data-fb-price-filter]').forEach(function (btn) {
        var active = (btn.getAttribute('data-fb-price-filter') || 'all') === value;
        btn.classList.toggle('is-selected', active);
      });
    }

    function applyFilters(catKey) {
      var hasCats = catButtons().length > 0;
      productLinks().forEach(function (a) {
        var inCat = true;
        if (hasCats && catKey) {
          var parent = a.getAttribute('data-fb-parent-cat') || '';
          inCat = parent === catKey;
        }
        a.hidden = !(inCat && matchesPriceFilter(a));
      });
    }

    function setActiveCat(btn) {
      if (!btn) {
        catButtons().forEach(function (b) {
          b.classList.remove('is-active');
          if (b.getAttribute('role') === 'tab') {
            b.setAttribute('aria-selected', 'false');
          }
        });
        return;
      }
      var key = btn.getAttribute('data-fb-cat-key') || '';
      catButtons().forEach(function (b) {
        var active = (b.getAttribute('data-fb-cat-key') || '') === key;
        b.classList.toggle('is-active', active);
        if (b.getAttribute('role') === 'tab') {
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        }
      });
    }

    function setActiveProductLink(el) {
      productLinks().forEach(function (a) {
        var active = el && a === el;
        a.classList.toggle('is-selected', !!active);
      });
    }

    function filterProductsByCat(catKey) {
      productLinks().forEach(function (a) {
        var parent = a.getAttribute('data-fb-parent-cat') || '';
        a.hidden = parent !== catKey;
      });
    }

    function findCatByKey(key) {
      var found = null;
      catButtons().forEach(function (b) {
        if (found) return;
        if ((b.getAttribute('data-fb-cat-key') || '') === key) found = b;
      });
      return found;
    }

    function findProductByKey(key) {
      var found = null;
      productLinks().forEach(function (a) {
        if (found) return;
        if ((a.getAttribute('data-fb-product-key') || '') === key) found = a;
      });
      return found;
    }

    function selectCat(catBtn, opts) {
      if (!catBtn) return;
      var catKey = catBtn.getAttribute('data-fb-cat-key') || '';
      setActiveCat(catBtn);
      applyFilters(catKey);
      setQueryParams({ fb_cat: catKey, fb_sub: null });

      var highlightKey = opts && opts.productKey;
      if (highlightKey) {
        var pl = findProductByKey(highlightKey);
        if (pl && !pl.hidden) setActiveProductLink(pl);
      } else {
        setActiveProductLink(null);
      }
      updateProductCount();
      var sortEl = container.querySelector('[data-fb-sort]');
      if (sortEl) sortVisibleProducts(container, sortEl.value || 'az');
    }

    container.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-fb-open-filter]')) {
        e.preventDefault();
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
        return;
      }
      if (t.closest('[data-fb-close-filter]')) {
        e.preventDefault();
        if (dialog && typeof dialog.close === 'function') dialog.close();
        return;
      }

      var catBtn = t.closest('[data-fb-cat][data-fb-cat-key]');
      if (catBtn && container.contains(catBtn)) {
        e.preventDefault();
        selectCat(catBtn, { productKey: null });
        if (dialog && catBtn.closest && catBtn.closest('[data-fb-filter-dialog]')) {
          dialog.close();
        }
      }
    });

    var sortEl = container.querySelector('[data-fb-sort]');
    if (sortEl) {
      sortEl.addEventListener('change', function () {
        sortVisibleProducts(container, sortEl.value || 'az');
      });
    }

    if (dialog) {
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });
    }

    container.addEventListener('click', function (e) {
      var priceBtn = e.target.closest('[data-fb-price-filter]');
      if (priceBtn && container.contains(priceBtn)) {
        e.preventDefault();
        activePriceFilter = priceBtn.getAttribute('data-fb-price-filter') || 'all';
        setActivePriceButton(activePriceFilter);
        if (!cats.length) {
          applyFilters(null);
        } else {
          var activeCat = container.querySelector('[data-fb-cat][data-fb-cat-key].is-active') || cats[0];
          if (activeCat) applyFilters(activeCat.getAttribute('data-fb-cat-key') || '');
        }
        setActiveProductLink(null);
        updateProductCount();
        if (sortEl) sortVisibleProducts(container, sortEl.value || 'az');
        if (dialog && typeof dialog.close === 'function') dialog.close();
      }
    });

    container.dataset.hubNavBound = '1';

    if (!cats.length) {
      applyFilters(null);
      setActivePriceButton(activePriceFilter);
      setActiveCat(null);
      setActiveProductLink(null);
      updateProductCount();
      if (sortEl) sortVisibleProducts(container, sortEl.value || 'az');
      return;
    }

    var startCat = catButtons()[0];
    if (qsProd) {
      var prodEl = findProductByKey(qsProd);
      if (prodEl) {
        var parentCatKey = prodEl.getAttribute('data-fb-parent-cat') || '';
        var catFromProd = parentCatKey && findCatByKey(parentCatKey);
        if (catFromProd) startCat = catFromProd;
      }
    } else if (qsCat) {
      var fromQs = findCatByKey(qsCat);
      if (fromQs) startCat = fromQs;
    }
    selectCat(startCat, { productKey: qsProd });
    setActivePriceButton(activePriceFilter);
  }

  function run() {
    document.querySelectorAll('.fb-hub[data-fb-hub-mode="link"]').forEach(function (el) {
      initHubNavigator(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('.fb-hub[data-fb-hub-layout="cat-product"]');
    if (root) initHubNavigator(root);
  });
})();
